import { SetterOrUpdater, useRecoilState, useRecoilValue } from "recoil";
import {
  defaultRequisitions,
  gridSearchText,
  searchRequisitions,
} from "./atoms";
import { searchCharacterCountValid } from "./helpers";
import { UserDefaultRequisitionsResponse } from "./types";

export const useRequisitionSetter = (): {
  searchText: string;
  setRequisitions: SetterOrUpdater<UserDefaultRequisitionsResponse | undefined>;
} => {
  const searchText = useRecoilValue(gridSearchText);
  const [, setRequisitions] = useRecoilState(defaultRequisitions);
  const [, setSearchRequisitions] = useRecoilState(searchRequisitions);
  return {
    searchText: searchText || "",
    setRequisitions: searchCharacterCountValid(searchText || "")
      ? setSearchRequisitions
      : setRequisitions,
  };
};
